import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MachineCard, MachineCardImg } from "../Investment/Investment.styled";
import {
  MachineSellValueText,
  SellButton,
  SellCard,
  SellMinerContainer,
} from "./SellMiner.styled";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { sellMiner } from "../../feature/minersOwned/MinersOwnedActions";
import { FormError } from '../Auth.styled'
import { clearInputError } from "../../feature/inputError/inputErrorSlice";
import { getUserBalance } from "../../feature/wallet/WalletActions";
import ReactLoading from "react-loading";
import SuccessPage from "../SuccessPage/SuccessPage";

const SellMiner = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1);
  const [sell, setSell] = useState(false);
  const { user } = useSelector((state) => state.user);
  const { inputError } = useSelector((state) => state.inputError);
  const { loading } = useSelector((state) => state.minersOwned);
  const machine = location.state !== null && location.state.data.machine_set;
  const qty = location.state !== null && location.state.data.quantity;
  const price_after_perc = (((machine.price * 40) / 100) * quantity).toFixed(2);

  const onSubmit = () => {
    dispatch(
      sellMiner({ user: user.id, machine: machine.id, quantity: quantity })
    )
      .unwrap()
      .then((res) => setSell(true));
  };

  const initialValues = {};

  const validationSchema = Yup.object({});

  const formik = useFormik({
    onSubmit,
    initialValues,
    validationSchema,
  });

  useEffect(() => {
    location.state === null && navigate("/miners-owned");
  }, [location.state, navigate]);

  useEffect(() => {
    Object.keys(user).length && dispatch(getUserBalance({ user: user }));
    dispatch(clearInputError());
  }, [dispatch, user]);

  return (
    <>
      {sell ? (
        <SuccessPage
          message="Processing Miner Sale"
          links={[{ link: "/miners-owned", name: "See Miners Owned" }]}
        />
      ) : (
        <SellMinerContainer>
          <form onSubmit={formik.handleSubmit}>
            <MachineCard style={{ flexDirection: "column" }}>
              <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                <div>
                  <MachineCardImg alt="machine1" src={machine.image} />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ marginBlock: "5px" }}>
                    <div>{machine.name}</div>
                    <MachineSellValueText>
                      {machine.price} TRX
                    </MachineSellValueText>
                  </div>
                  <div style={{ marginBlock: "5px" }}>
                    <div>Sell Fee:</div>
                    <MachineSellValueText>60%</MachineSellValueText>
                  </div>
                </div>
              </div>
            </MachineCard>
            <SellCard>
              <span>Amount After Fee:</span> <span>{price_after_perc} TRX</span>
            </SellCard>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid #7B36EE",
                padding: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  Quantity:{" "}
                  <input
                    style={{
                      borderRadius: 0,
                      border: "1px solid grey",
                      height: "30px",
                      width: "20%",
                      marginInlineStart: "5px",
                    }}
                    value={quantity}
                    readOnly
                  />
                  <button
                    type="button"
                    style={{
                      borderRadius: 0,
                      height: "40px",
                      width: "40px",
                      marginInline: "7px",
                    }}
                    onClick={() => setQuantity(quantity - 1)}
                    disabled={quantity === 1}
                  >
                    -
                  </button>
                  <button
                    type="button"
                    style={{ borderRadius: 0, height: "40px", width: "40px" }}
                    onClick={() => setQuantity(quantity + 1)}
                    disabled={quantity === qty}
                  >
                    +
                  </button>
                </div>
              </div>
              <SellButton type="submit" disabled={quantity === 0 || loading}>
                {loading ? (
                  <ReactLoading
                    type={"spinningBubbles"}
                    height={"20px"}
                    width={"20px"}
                  />
                ) : (
                  "Sell"
                )}
              </SellButton>
            </div>
            <FormError>
                {inputError !== undefined
                  ? inputError
                      ? inputError
                      : null
                  : null
                }
              </FormError>
          </form>
        </SellMinerContainer>
      )}
    </>
  );
};

export default SellMiner;
